export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_USER_ID = 'LOGIN_USER_ID';

export const POST_MEDICINE = 'POST_MEDICINE';
export const GET_MEDICINE = 'GET_MEDICINE';
export const UPDATE_MEDICINE = 'UPDATE_MEDICINE';
export const DELETE_MEDICINE = 'DELETE_MEDICINE';

export const POST_PATIENT = 'POST_PATIENT';
export const GET_PATIENT = 'GET_PATIENT';
export const UPDATE_PATIENT = 'UPDATE_PATIENT';
export const DELETE_PATIENT = 'DELETE_PATIENT';

export const POST_TREATMENT = 'POST_TREATMENT';
export const GET_TREATMENT = 'GET_TREATMENT';
export const UPDATE_TREATMENT = 'UPDATE_TREATMENT';
export const DELETE_TREATMENT = 'DELETE_TREATMENT'; 4

export const POST_DOCTOR = 'POST_DOCTOR';
export const GET_DOCTOR = 'GET_DOCTOR';
export const UPDATE_DOCTOR = 'UPDATE_DOCTOR';
export const DELETE_DOCTOR = 'DELETE_DOCTOR';

export const POST_CLINIC = 'POST_CLINIC';
export const GET_CLINIC = 'GET_CLINIC';
export const UPDATE_CLINIC = 'UPDATE_CLINIC';
export const DELETE_CLINIC = 'DELETE_CLINIC';

export const POST_RECEPTIONIST = 'POST_RECEPTIONIST';
export const GET_RECEPTIONIST = 'GET_RECEPTIONIST';
export const UPDATE_RECEPTIONIST = 'UPDATE_RECEPTIONIST';
export const DELETE_RECEPTIONIST = 'DELETE_RECEPTIONIST';

export const LOGOUT = 'LOGOUT';
export const LOGIN_USER_TYPE = 'LOGIN_USER_TYPE';

export const GET_PATIENT_NAME = 'GET_PATIENT_NAME';
export const GET_SUGGESTED_PATIENT_IDS = 'GET_SUGGESTED_PATIENT_IDS';

export const GET_APPOINTMENT = 'GET_APPOINTMENT';
export const POST_APPOINTMENT = 'POST_APPOINTMENT';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const DELETE_APPOINTMENT = 'DELETE_APPOINTMENT';

export const GET_PRESCRIPTION = 'GET_PRESCRIPTION';
export const POST_PRESCRIPTION = 'POST_PRESCRIPTION';
export const UPDATE_PRESCRIPTION = 'UPDATE_PRESCRIPTION';
export const DELETE_PRESCRIPTION = 'DELETE_PRESCRIPTION';

export const CREATE_PRESCRIPTION = 'CREATE_PRESCRIPTION';
export const RESET = "RESET";
export const PRESCRIPTION_DETAILS = "PRESCRIPTION_DETAILS";

export const GET_TREATMENT_BY_ID = "GET_TREATMENT_BY_ID";
export const CREATE_BILL = "CREATE_BILL";
export const GET_INVOICE = "GET_INVOICE";
export const GET_ALL_INVOICES = "GET_ALL_INVOICES";

export const GET_PATIENT_VISITS = "GET_PATIENT_VISITS";
export const GET_INVOICE_STATS = "GET_INVOICE_STATS";

export const GET_EXITS_PATIEND_ID = "GET_EXITS_PATIEND_ID";
export const LOOKUP_NOT_APPLICABLE_FOR = "LOOKUP_NOT_APPLICABLE_FOR";
export const LOOKUP_SALTS = "LOOKUP_SALTS";
export const LOOKUP_NOTES = "LOOKUP_NOTES";
export const LOOKUP_MEDICINE_TYPE = "LOOKUP_MEDICINE_TYPE";
export const LOOKUP_CHIEF_COMPLAINT = "LOOKUP_CHIEF_COMPLAINT";
export const LOOKUP_TREATMENT_DETAILS = "LOOKUP_TREATMENT_DETAILS";
export const LOOKUP_DIAGNOSIS = "LOOKUP_DIAGNOSIS";